import { connectedAccount } from '@/api/payment';

const defaultState = () => ({
  account: null,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setAccount(state, payload) {
      state.account = payload;
    },
  },
  actions: {
    async getAccount({ commit }, id) {
      try {
        if (!id) return;
        const { data } = await connectedAccount.retrieve(id);
        commit('setAccount', data);
      } catch (e) {
        console.error(e);
      }
    },
  },
  getters: {
    accountId: state => state.account && state.account.id,
    account: state => state.account,
    isAccountActive: state => state.account && state.account.payouts_enabled,
  },
};
